// test57
(57 && 0);
